import React from "react";

export default function feedback() {
  return (
    <React.Fragment>
      <div className="container-main">
        <div>Feddback</div>
      </div>
    </React.Fragment>
  );
}
